import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';
import { Row, REFACTOR_DATE } from '../../Resources';
import ActivitiesRegistrationHeader from '../../ActivitiesRegistrationHeader';

export default function ServiceOrderRemotion({ lastRegister, activityData }) {
  if(moment(activityData?.updatedAt, 'YYYY-MM-DD HH:mm:ss').isBefore(REFACTOR_DATE)) {
    return(
      <Grid container>
        <Grid xs={12}>
          <ActivitiesRegistrationHeader activityData={activityData} />
        </Grid>
        <Grid container style={{ marginTop: 10 }}>
          <Grid xs={12}>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              <Row>
                <Typography color='primary'>
                  <b>Código da OS</b>
                </Typography>
                <Typography color='textSecondary'>{lastRegister?.serviceOrder?.serviceOrderCode}</Typography>
              </Row>
              <Row>
                <Typography color='primary'>
                  <b>Entrada</b>
                </Typography>
                <Typography color='textSecondary'>{moment(lastRegister?.serviceOrder?.entryDateTime).format('DD/MM/YYYY HH:mm:ss')}</Typography>
              </Row>
              <Row>
                <Typography color='primary'>
                  <b>Saída</b>
                </Typography>
                <Typography color='textSecondary'>{moment(lastRegister?.serviceOrder?.exitDateTime).format('DD/MM/YYYY HH:mm:ss')}</Typography>
              </Row>
              <Row>
                <Typography color='primary'>
                  <b>Placa</b>
                </Typography>
                <Typography color='textSecondary'>{lastRegister?.serviceOrder?.plate}</Typography>
              </Row>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader activityData={activityData} />
      </Grid>
      <Grid container style={{ marginTop: 10 }}>
        <Grid xs={12}>
          <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
            {Object.keys(lastRegister).includes('serviceOrderCode') && (
              <Row>
                <Typography color='primary'>
                  <b>Código da OS</b>
                </Typography>
                <Typography color='textSecondary'>{lastRegister?.serviceOrderCode}</Typography>
              </Row>
            )}
            {Object.keys(lastRegister).includes('entryDateTime') && (
              <Row>
                <Typography color='primary'>
                  <b>Entrada</b>
                </Typography>
                <Typography color='textSecondary'>{moment(lastRegister?.entryDateTime).format('DD/MM/YYYY HH:mm:ss')}</Typography>
              </Row>
            )}
            {Object.keys(lastRegister).includes('exitDateTime') && (
              <Row>
                <Typography color='primary'>
                  <b>Saída</b>
                </Typography>
                <Typography color='textSecondary'>{moment(lastRegister?.exitDateTime).format('DD/MM/YYYY HH:mm:ss')}</Typography>
              </Row>
            )}
            {Object.keys(lastRegister).includes('plate') && (
              <Row>
                <Typography color='primary'>
                  <b>Placa</b>
                </Typography>
                <Typography color='textSecondary'>{lastRegister?.plate || '--'}</Typography>
              </Row>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

ServiceOrderRemotion.propTypes = {
  lastRegister: PropTypes.object.isRequired,
  activityData: PropTypes.object.isRequired
}